import * as Sentry from '@sentry/browser';

export default () => {
  if (process.env.REACT_APP_SENTRY_URL) {
    Sentry.init({ dsn: process.env.REACT_APP_SENTRY_URL });

    Sentry.configureScope(scope => {
      scope.setTag('application', 'my-hoopla');
      scope.setTag('environment', process.env.REACT_APP_ENVIRONMENT);
    });
  }
}
